import { JobApplicantSubBaseViewController } from '@/views/portal/hr/my_profile/JobApplicantSubBaseViewController';

export class JobApplicationSubViewController extends JobApplicantSubBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {} );

		super( options );
	}

	render() {
		var $this = this;
		var list_tpl = Global.loadWidget( 'views/portal/hr/my_profile/MyProfileSubView.html' );
		var unique_id = this.sub_view_id + '-' + this.model.id;
		this.unique_id = unique_id;
		this.sub_view = _.template( list_tpl )( {} );
		if ( this.table_container.find( '.table-container' ).length == 0 ) {
			this.table_container.html( '<div class="table-responsive"><table class="table table-condensed table-bordered table-container"><thead></thead><tbody></tbody></table></div>' );
		}
		if ( this.table_container.find( '#' + unique_id ).length === 0 ) {
			var tbody = $( '<tr>' ).attr( 'id', unique_id );
			$( this.table_container.find( 'tbody' )[0] ).append( tbody );
		} else {
			this.table_container.find( '#' + unique_id ).html( '' );
		}
		var thead = $( '<tr>' );
		for ( var column in this.display_columns ) {
			if ( !this.display_columns.hasOwnProperty( column ) ) {
				continue;
			}
			var column_val;
			switch ( column ) {
				default:
					if ( !this.model.get( column ) ) {
						column_val = '';
					} else {
						column_val = this.model.get( column );
					}
					if ( column === 'job_vacancy' ) {
						var url = Global.getBaseURL( null, true, true ).replace(/#!m=.*?(&|$)/g, '#!m=PortalJobVacancyDetail&id=' + this.model.get( 'job_vacancy_id' ) + '$1'); //Be sure to include any other URL args.
						this.table_container.find( '#' + unique_id ).append( '<td><a href="' + url + '">' + column_val + '</a></td>' );
					} else {
						this.table_container.find( '#' + unique_id ).append( '<td>' + column_val + '</td>' );
					}
					break;
			}
			thead.append( '<th>' + this.display_columns[column] + '</th>' );
		}
		thead.append( '<th>' + $.i18n._( 'Action' ) + '</th>' );
		if ( this.table_container.find( 'thead' ).html() === '' ) {
			this.table_container.find( 'thead' ).html( thead );
		}
		this.table_container.find( '#' + unique_id ).append( this.sub_view );
		this.table_container.find( '#' + unique_id ).find( '.edit-icon' ).remove();
		// this.table_container.find('#'+unique_id).find('.edit-icon').unbind('click').bind('click', function( e ) {
		// 	$this['get'+$this.sub_view_id](function() {
		// 		$this.setEditView();
		// 	})
		// });
		this.table_container.find( '#' + unique_id ).find( '.delete-icon' ).unbind( 'click' ).bind( 'click', function( e ) {
			$this['get' + $this.sub_view_id]( function() {
				$this.onDeleteClick();
			} );
		} );
	}

	getJobApplication( callback ) {
		var $this = this;
		var filter = {};
		filter.filter_data = {};
		filter.filter_data.id = this.model.id;
		this.api['getJobApplication']( filter, {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					var result_data = result.getResult();
					if ( !result_data ) {
						result_data = [];
					}
					result_data = result_data[0];
					$this.model.set( result_data );
					if ( callback ) {
						callback();
					}
				} else {
					$this.showErrorAlert( result );
					ProgressBar.closeOverlay();
				}
			}
		} );
	}

	//
	// setCurrentEditRecordData: function() {
	// 	this._super('setCurrentEditRecordData');
	// 	var field_selector;
	// 	var field_control;
	// 	//Set current edit record data to all widgets
	// 	for ( var key in this.model.attributes ) {
	// 		if ( !this.model.has( key ) ) {
	// 			continue;
	// 		}
	// 		switch ( key ) {
	// 			default:
	// 				if ( this.model.get(key) === false ) {
	// 					this.model.set( key, '' );
	// 				}
	// 				field_selector = '.form-control[name="' + key + '"]';
	// 				field_control = this.$(field_selector );
	// 				if ( field_control && field_control[0] ) {
	// 					this.$(field_selector ).val( this.model.get(key) );
	// 				}
	// 				break;
	//
	// 		}
	// 	}
	// },
	//
	// onFormItemChange: function( e, doNotValidate ) {
	// 	var key = e.currentTarget.name;
	// 	this.model.set( key, $(e.currentTarget).val() );
	// 	if ( !doNotValidate ) {
	// 		this.validate();
	// 	}
	// },

}